<template>
  <section>
    <custom-design
      :base-tag-svg-img-path="baseTagSvgImgPath ? getImage(baseTagSvgImgPath) : require('@/assets/images/collars/buckle_500x500.svg')"
      :design-svg-img-path="false"
      :text1="personalizationTextConfig.text1"
      :text2="personalizationTextConfig.text2"
      :text3="personalizationTextConfig.text3"
      :scale="scale"
      :height="height"
      :boundary-padding="25"
      canvas-b-g-color="#f7f7f7"
      :canvas-styles="getCanvasStyles"
    />
  </section>
</template>

<script>
import getImage from '@/mixins/getImage';
import CustomDesign from '@/components/CustomDesign';

export default {
  name: 'CollarLeashPersonalizePreview',
  components: { CustomDesign },
  mixins: [getImage],
  props: {
    personalizationSelected: {
      type: Boolean,
      default: true,
      required: false,
    },
    baseTagSvgImgPath: {
      type: [String, Boolean],
      default: null,
      required: false,
    },
    showLabels: {
      type: Boolean,
      default: true,
      required: false,
    },
    height: {
      type: Number,
      default: 500,
      required: false,
    },
    scale: {
      type: Number,
      default: 0.8,
      required: false,
    },
    homeSafeId: {
      type: String,
      default: 'U237JC9Z',
      required: false,
    },
    phoneNumber: {
      type: [String, Number],
      default: '',
      required: true,
    },
  },
  computed: {
    personalizationTextConfig() {
      return {
        text1: {
          offsetX: 0,
          offsetY: -120,
          boundaryPadding: 60,
          color: '#4A4A4A',
          text: 'View my profile at:\nwww.docupet.com/',
          minFontSize: 38,
          maxFontSize: 39,
          fontFamily: 'Lato',
          options: {
            fontSize: 38,
          },
          ...(this.showLabels
            ? {
                labelOptions: {
                  text: "Your pet's profile link\nand HomeSafe® ID\nis automatically included",
                  offsetX: 250,
                  offsetY: -60,
                  fontWeight: 600,
                  fontFamily: 'Lato',
                  fontSize: 50,
                  styles: {
                    1: Array.from({ length: 16 }, () => ({ fontWeight: 600, fill: '#02294f' })).reduce(
                      (obj, item, index) => ({
                        ...obj,
                        [index]:
                          index < 8 || index > 11
                            ? item
                            : {
                                ...item,
                                fontStyle: 'italic',
                              },
                      }),
                      {}
                    ),
                  },
                },
                lineOptions: {
                  offsetX1: 1.15,
                  offsetY1: -30,
                  offsetX2: 20,
                  offsetY2: -20,
                },
              }
            : {}),
        },
        text2: {
          offsetX: 0,
          offsetY: -20,
          boundaryPadding: 60,
          color: '#4A4A4A',
          text: this.homeSafeId?.toUpperCase(),
          minFontSize: 58,
          maxFontSize: 59,
          fontFamily: 'Lato',
          options: {
            fontSize: 58,
          },
        },
        text3: {
          offsetX: 0,
          offsetY: 65,
          boundaryPadding: 30,
          color: '#4A4A4A',
          text:
            this.personalizationSelected !== null && this.phoneNumber
              ? (this.personalizationSelected === false ? '1-' : '') + this.phoneNumberFormatter(this.phoneNumber)
              : '(123-Your-Number)',
          minFontSize: this.personalizationSelected === null || !this.phoneNumber ? 49 : 55,
          maxFontSize: this.personalizationSelected === null || !this.phoneNumber ? 40 : 56,
          fontFamily: 'Lato',
          options: {
            fontSize: 55,
          },
          ...(this.showLabels
            ? {
                labelOptions: {
                  text: 'Use our 24/7 HomeSafe®\nhotline number or add\nyour contact phone\nnumber',
                  offsetX: 250,
                  offsetY: 30,
                  fontFamily: 'Lato',
                  fontSize: 50,
                  styles: {
                    0: Array.from({ length: 22 }, () => ({ fontWeight: 600, fill: '#02294f' })).reduce(
                      (obj, item, index) => ({
                        ...obj,
                        [index]:
                          index < 17 || index > 20
                            ? item
                            : {
                                ...item,
                                fontStyle: 'italic',
                              },
                      }),
                      {}
                    ),
                    1: Array.from({ length: 21 }, () => ({ fontWeight: 600, fill: '#02294f' })).reduce(
                      (obj, item, index) => ({
                        ...obj,
                        [index]: item,
                      }),
                      {}
                    ),
                    2: Array.from({ length: 18 }, () => ({ fontWeight: 600, fill: '#02294f' })).reduce(
                      (obj, item, index) => ({
                        ...obj,
                        [index]: item,
                      }),
                      {}
                    ),
                    3: {
                      ...Array.from({ length: 6 }, () => ({ fontWeight: 600, fill: '#02294f' })).reduce(
                        (obj, item, index) => ({
                          ...obj,
                          [index]: item,
                        }),
                        {}
                      ),
                    },
                  },
                },
                lineOptions: {
                  offsetX1: 0.95,
                  offsetY1: 5,
                  offsetX2: 20,
                  offsetY2: -65,
                },
              }
            : {}),
        },
      };
    },
    getCanvasStyles() {
      return 'border-radius: 1rem';
    },
  },
  methods: {
    phoneNumberFormatter(phone) {
      if (phone && phone.length > 0) {
        let x = phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        return !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
      }
    },
  },
};
</script>

<style scoped></style>
